export default {
  title: '{type} migration State',
  resetMessage: 'Are you sure you want to reset the migration status for {count} {type}?\n'
    + 'As a consequence all {type} will be migrated from the first available data on PT9800.',
};
